import { Menu } from "antd";
import { Link } from "react-router-dom";

const { SubMenu, Item } = Menu;

export function RecursiveMenu(data: any[], parentKey = "") {
  return data.map(
    (
      { key, label, icon, to, click, visible, children = [], hidden = false },
      index,
    ) => {
      if (hidden) return;
      const itemKey = parentKey ? `${parentKey}-${index}` : `${index}`;
      if (visible) {
        if (!children?.length) {
          return (
            <Item key={key || itemKey} icon={icon}>
              {to ? (
                <Link
                  to={to}
                  className="capitalize"
                  onClick={click || undefined}
                >
                  {label}
                </Link>
              ) : click ? (
                <div onClick={click} className="capitalize">
                  {label}
                </div>
              ) : (
                <div className="capitalize">{label}</div>
              )}
              {/* onClick */}
            </Item>
          );
        }

        return (
          <SubMenu
            // style={{ paddingLeft: 20 }}
            popupOffset={[500, 500]}
            key={itemKey}
            title={label}
            icon={icon}
          >
            {RecursiveMenu(children, itemKey)}
          </SubMenu>
        );
      }

      // if unassigned visibility
      if (visible == null) {
        if (!children?.length) {
          return (
            <Item key={key || itemKey} icon={icon}>
              {to ? (
                <Link
                  to={to}
                  className="capitalize"
                  onClick={click || undefined}
                >
                  {label}
                </Link>
              ) : click ? (
                <div onClick={click} className="capitalize">
                  {label}
                </div>
              ) : (
                <div className="capitalize">{label}</div>
              )}
              {/* onClick */}
            </Item>
          );
        }

        return (
          <SubMenu
            // style={{ paddingLeft: 20 }}
            popupOffset={[500, 500]}
            key={itemKey}
            title={label}
            icon={icon}
          >
            {RecursiveMenu(children, itemKey)}
          </SubMenu>
        );
      }
    },
  );
}
